import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDonations, useVerifyDonation } from '../../../api/donations';
import { DonationStatus } from '@spi/shared';
import { StatusBadge } from '../shared/StatusBadge';
import { Pagination } from '../shared/Pagination';
import toast from 'react-hot-toast';

export function DonationVerifyList() {
  const [statusFilter, setStatusFilter] = useState<string>(DonationStatus.RECEIVED);
  const [page, setPage] = useState(1);
  const { data, isLoading } = useDonations({
    status: (statusFilter || undefined) as DonationStatus | undefined,
    page,
    limit: 20,
  });
  const verify = useVerifyDonation();

  return (
    <div>
      <div className="mb-6">
        <select
          value={statusFilter}
          onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}
          className="input max-w-[200px] text-sm py-2"
        >
          <option value="">All Statuses</option>
          <option value={DonationStatus.PLEDGED}>Pledged</option>
          <option value={DonationStatus.SHIPPED}>Shipped</option>
          <option value={DonationStatus.DELIVERED}>Delivered</option>
          <option value={DonationStatus.RECEIVED}>Received (Pending Verification)</option>
          <option value={DonationStatus.VERIFIED}>Verified</option>
        </select>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
        </div>
      ) : (
        <>
          <div className="space-y-3">
            {data?.data.map((donation) => (
              <div key={donation.id} className="card p-5">
                <div className="flex items-start justify-between">
                  <div>
                    <Link to={`/marketplace/donations/${donation.id}`} className="font-semibold text-spi-charcoal hover:text-spi-green">
                      {donation.projectTitle}
                    </Link>
                    <p className="text-sm text-spi-slate">
                      {donation.donorOrganization} &rarr; {donation.recipientOrganization} &middot; {donation.askCrop}
                    </p>
                    <p className="text-xs text-spi-slate mt-1">{donation.quantityKg > 0 ? `${donation.quantityKg}kg` : ''}{donation.quantityPackets > 0 ? ` ${donation.quantityPackets}pkts` : ''} &middot; ${donation.fairMarketValueUsd.toLocaleString()}</p>
                  </div>
                  <StatusBadge status={donation.status} />
                </div>
                {donation.status === DonationStatus.RECEIVED && (
                  <div className="mt-3">
                    <button
                      onClick={async () => { await verify.mutateAsync(donation.id); toast.success('Donation verified'); }}
                      disabled={verify.isPending}
                      className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-emerald-100 text-emerald-700 hover:bg-emerald-200"
                    >
                      Verify
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
          {data && <Pagination page={data.page} totalPages={data.totalPages} onPageChange={setPage} />}
        </>
      )}
    </div>
  );
}
